<template>
  <div class="footer-com" :style="{ position: positive }">
    <div class="left">
      <img src="../assets/logo.png" alt="" />
    </div>
    <div class="right">
      © 上海智多鱼信息科技有限公司. All Rights Reserved. 备案号：<a target="_blank" rel="noopener" href="https://beian.miit.gov.cn/">沪ICP备2023007001号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["positive"],
  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 350px) and (max-width: 750px) {
    .footer-com {
      display: block;
      padding: 30px 0px;
      .left {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-bottom: 30px;
      }
      .right {
        width: 70%;
        margin: 0 auto;
        text-align: center;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
  @media screen and (min-width: 751px) {
    .footer-com {
      height: 100px;
      display: flex;
      justify-content: center;

      .left {
        display: flex;
        justify-content: right;
        align-items: center;
        margin-right: 30px;
      }
      .right {
        height: 100%;
        font-size: 18px;
        line-height: 100px;
      }
    }
    
  }
.footer-com {
  // position: absolute;
  width: 100%;
  // bottom: 0;
  // z-index: 999;
  background: #080808;
  
  .left {
    // width: 30%;
    height: 100%;
    
    img {
      width: 100px;
    }
  }
  .right {
    // width: 70%;
    
    font-family: PingFang SC;
    font-weight: 400;
    color: #CCCCCC;
  }
}
</style>